import AxiosConfig from "@/config/axiosConfig/AxiosConfig";
import config from "@/config";

const PropertiesService = {
    getFilter: async (params) => {
        try {
            const resp = await AxiosConfig.get(config.api.properties, { params });
            return resp.data;
        } catch (err) {
            console.error(err)
            return Promise.reject(err)
        }
    },

}
export default PropertiesService;